// src/Components/Footer/footerNav.ts
import { routeTo } from "../CustomHooks/routeChange";
import { KeyCloakService } from "../../Auth/KeyCloak";
import { getRecoilStateValue } from "../../Orchestrator/Recoils/Events/Recoil";
import { legalDocFromPath, openLegalDoc } from "../../Orchestrator/Recoils/LegalDocModalAtom";
import { signInAction } from "../../Actions/UIActions/MyAccount/SignInAction";
import type { FooterTarget } from "./footerConfig";

/**
 * Performs the navigation for a footer link target.
 * `external` targets are rendered as real anchors, so they are a no-op here.
 */
export function handleFooterTarget(target: FooterTarget): void {
  switch (target.kind) {
    case "route": {
      // Legal documents open in the in-app popup so the user never loses
      // their place; the real pages stay reachable for mobile WebView links.
      const legalDoc = legalDocFromPath(target.path);
      if (legalDoc) {
        openLegalDoc(legalDoc);
        return;
      }
      routeTo(target.path);
      return;
    }
    case "action":
      if (target.action === "signIn") {
        // Mirror the top bar: logged-in -> /my-account, guest -> Keycloak login.
        const isAuthenticated = !!getRecoilStateValue<boolean>("isAuthenticatedStateAtom");
        signInAction.setParams({ isAuthenticated, login: () => KeyCloakService.login() });
        signInAction.execute();
      }
      return;
    case "external":
      // Handled declaratively via <a href target="_blank">.
      return;
    case "none":
      // Inert placeholder: not linked yet.
      return;
  }
}
